export default function myopic(thingIveJustLearned, thingIveUsed) {
  return `${thingIveJustLearned} replaces ${thingIveUsed}. I don't see any reason to use ${thingIveUsed} anymore.`;
}